module.exports = __webpack_public_path__ + "assets/congo.88c0de503eeee1dddee8785678409588.png";


//////////////////
// WEBPACK FOOTER
// ./assets/flags/congo.png
// module id = 214
// module chunks = 0